import type { Blueprint } from '../../base/blueprints/Blueprint';
import { instanceOfBlueprint } from '../../base/blueprints/Blueprint';
import type { AlwaysChoice } from '../enums/AlwaysChoice';
import type { NeverChoice } from '../enums/NeverChoice';
import type { InternallyChoice } from '../enums/InternallyChoice';
import type { WhenChoice } from '../enums/WhenChoice';

export interface ReadonlyBlueprint extends Blueprint
{
    readonly: AlwaysChoice | NeverChoice | InternallyChoice | WhenChoice;
    readonlyWhen: string;
}

export const instanceOfReadonlyBlueprint = (object: any): object is ReadonlyBlueprint =>
{
    return instanceOfBlueprint(object) && 'readonly' in object;
};
